import React, { forwardRef } from "react";

const variants = {
  primary: "border-[var(--primaryColor)] bg-[var(--primaryColor)] text-white hover:brightness-90 focus:ring-[var(--primaryColor)]",
  outline: "border-[var(--primaryColor)] bg-farmazon-surface text-[var(--primaryColor)] hover:bg-farmazon-hover focus:ring-[var(--primaryColor)]",
  secondary: "border-farmazon-border bg-farmazon-surface text-farmazon-text hover:bg-farmazon-hover focus:ring-slate-500/20",
  ghost: "border-transparent bg-transparent text-farmazon-text-muted hover:bg-farmazon-hover focus:ring-slate-500/20",
  success: "border-green-600 bg-green-50 text-green-700 hover:bg-green-100 focus:ring-green-600",
  danger: "border-red-600 bg-red-50 text-red-700 hover:bg-red-100 focus:ring-red-600",
  ai: "border-purple-600 bg-purple-50 text-purple-700 hover:bg-purple-100 focus:ring-purple-600",
};

const sizes = {
  sm: "h-8 px-3 text-xs",
  md: "h-10 px-4 text-sm",
  lg: "h-11 px-5 text-sm",
};

const Button = forwardRef((props, ref) => {
  const {
    children,
    className = "",
    disabled = false,
    loading = false,
    size = "md",
    type = "button",
    variant = "primary",
    ...buttonProps
  } = props;

  return (
    <button
      {...buttonProps}
      ref={ref}
      type={type}
      disabled={disabled || loading}
      className={`inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl border border-solid font-semibold shadow-sm outline-none transition-colors focus:ring-2 disabled:cursor-not-allowed disabled:opacity-50 ${variants[variant] || variants.primary} ${sizes[size] || sizes.md} ${className}`}
    >
      {loading && (
        <span className="h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent" aria-hidden="true" />
      )}
      {children}
    </button>
  );
});

Button.displayName = "Button";

export default Button;
